"use strict";

angular.module('app.models.enum', ['restmod']).//
/* Data Model */
factory('__Enum', ['restmod', 'RMUtils', 'appConfig', function (restmod) {
    'ngInject';
    
    return restmod.model('System/ResolveEnums/').mix('BaseModel').mix({
            $hooks: {
                'after-save': function (_req) {
                    for (var i = 0; i < _req.data.length; ++i) {
                        var data = _req.data[i]['Metadata'];
                        var enumName = _req.data[i]['FilterConfiguration'].EnumName;
                        var filterProfil = _req.data[i]['FilterConfiguration'].FilterProfile;

                        if (!this[enumName]) {
                            this[enumName] = {};
                        }

                        if (!this[enumName][filterProfil]) {
                            this[enumName][filterProfil] = [];
                            this[enumName][filterProfil+'AsKey'] = {};
                        }

                        var j = 0;
                        for (var key in data) {
                            var entry = data[key];
                            entry['$pk'] = parseInt(key);
                            entry.EnumValueKeyNumber = entry['$pk'];
                            this[enumName][filterProfil][j++] = entry;

                        }
                        for (var key in data) {
                            var entry = data[key];
                            entry['$pk'] = parseInt(key);
                            entry.EnumValueKeyNumber = entry['$pk'];
                            this[enumName][filterProfil+'AsKey'][parseInt(key)] = entry;

                        }
                    }
                },
                'before-fetch-many': function (_req) {
                    _req.method = 'POST';
                    _req.data = _req.params;
                    delete _req['params'];
                },
                'after-fetch-many': function (_req) {
                    var data = _req.data[0]['Metadata'];
                    var i = 0;
                    for (var key in data) {
                        var entry = data[key];
                        entry['$pk'] = parseInt(key);
                        entry.EnumValueKeyNumber = entry['$pk'];
                        this[i++] = entry;
                    }
                }
            }
        });
    }]
);
